import { createApp } from 'vue'
import 'normalize.css';
import App from './App.vue'
import router from './router'
import '@/utils/remAdaptor'
import staticConfig from '@/constant'


// 修改网站title
document.title = staticConfig.title

createApp(App).use(router).mount('#app')
